import { Component, h, render } from "preact";
import { IReactConfiguration, ITemplate } from "../../typings";
import Uploader from "../uploader";

import TemplateController from "../../shared/controller/template-controller";
import OutputController from "../../shared/controller/output-controller";
import EventController from "../../shared/controller/event-controller";
import LabelOptions from "./label-options";
import Viewer from "./viewer";
import UnitSystemController from "../../shared/controller/unit-system-controller";
import SizeController from "../../shared/controller/size-controller";
import ImageRenderer from "./viewer/ImageRenderer";
import ColorController from "../../shared/controller/color-controller";

export default class LabelUploader extends Component<
  ILabelUploaderProps,
  ILabelUploaderState
> {
  constructor(props: ILabelUploaderProps) {
    super(props);

    this.state = {
      template: null,
    };

    this.setTemplate = this.setTemplate.bind(this);
  }

  componentDidUpdate(): void {
    if (this.props.templateLoaded === true && this.state.template === null) {
      this.setTemplate();
    }
  }

  setTemplate(): void {
    const template: ITemplate = this.props.templateController.getTemplate();
    if (template) {
      //Save template
      this.setState({
        template,
      });
    }

    this.renderCanvas();
    this.renderOptions();
    this.renderPreviewRenderer();

    if (this.props.bind) {
      this.props.bind(this);
    }
  }

  renderCanvas(): void {
    let selector: string = this.props.conf.canvas_target;
    if (this.props.conf.target) {
      selector = this.props.conf.target + " " + selector;
    }

    render(
      <Viewer
        conf={this.props.conf}
        selector={selector}
        main={this.props.main}
        templateLoaded={this.props.templateLoaded}
        eventController={this.props.eventController}
        outputController={this.props.outputController}
        sizeController={this.props.sizeController}
        templateController={this.props.templateController}
        unitSystemController={this.props.unitSystemController}
        colorController={this.props.colorController}
        originalName="original"
        originalMetaName="original-meta"
        originalPngName="original-png"
        croppedDataName="cropped-data"
        option={this.props.templateController.getOptionByCode("file-front")}
      />,
      document.body.querySelector(selector),
    );
  }

  renderOptions(): void {
    let selector: string = this.props.conf.options_target;
    if (this.props.conf.target) {
      selector = this.props.conf.target + " " + selector;
    }

    render(
      <LabelOptions
        conf={this.props.conf}
        main={this.props.main}
        template={this.state.template}
        eventController={this.props.eventController}
        outputController={this.props.outputController}
        sizeController={this.props.sizeController}
        templateController={this.props.templateController}
        unitSystemController={this.props.unitSystemController}
        templateLoaded={this.props.templateLoaded}
        colorController={this.props.colorController}
      />,
      document.body.querySelector(selector),
    );
  }

  render(): JSX.Element {
    return null;
  }

  private renderPreviewRenderer(): void {
    const previewRendererWrapper: HTMLSpanElement =
      document.createElement("span");

    render(
      <ImageRenderer
        conf={this.props.conf}
        outputController={this.props.outputController}
        sizeController={this.props.sizeController}
        externalController={this.props.main.externalController}
        width={400}
        height={400}
        renderOnDemandEventName="render_preview"
        renderedOnDemandEventName="preview_rendered"
        renderFoldLines
        renderSewingAllowanceLines
        responsive
        originalName="original"
        originalMetaName="original-meta"
        originalPngName="original-png"
        croppedDataName="cropped-data"
        renderEdgeSkew
        renderCordHole
      />,
      previewRendererWrapper,
    );
    this.setState({ previewRendererWrapper });
  }
}

interface ILabelUploaderState {
  template: ITemplate;
  previewRendererWrapper?: HTMLSpanElement;
  imageRendererWrapper?: HTMLSpanElement;
}

interface ILabelUploaderProps {
  bind: Function;
  conf: IReactConfiguration;
  main: Uploader;
  templateLoaded: boolean;

  eventController: EventController;
  outputController: OutputController;
  sizeController: SizeController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
  colorController: ColorController;
}
